import { TbChevronDown } from "react-icons/tb";
import "./Dropdown.css";
import { useEffect, useState } from "react";

const Dropdown = ({title, items, img, className}) => 
{
  const [enabled, setEnabled] = useState(false);
  
  const getClasses = () =>{
    let classString = `dropdownContent ${className}`;

    if(enabled)
      classString += " dropdownMobile";

    return classString;
  }

  return (
    <div className="dropdown">
        <button className="dropdownBtn" onClick={() => setEnabled(!enabled)}>
            <img src={img} className="size-9 border border-glgray-700 rounded-md"/>
            {title}
            <TbChevronDown />
        </button>
        <div className={getClasses()}>
            { items.map((item) => {
                return item
            })}
        </div>
    </div>
  )
}

export default Dropdown;